// Radha — French (fr-FR) locale pack.
// Shell chrome only: nav, header, repeated states and actions. Panel body
// copy is intentionally absent — it is finance/legal terminology that needs
// native review, and t() falls back to English until it is translated.
const fr = {
  "nav.overview": "Aperçu",
  "nav.collections": "Recouvrement",
  "nav.disputes": "Litiges",
  "nav.contracts": "Contrats",
  "nav.invoicing": "Facturation",
  "nav.recurring": "Récurrent",
  "nav.statements": "Relevés",
  "nav.creditNotes": "Avoirs",
  "nav.gst": "Taxes",
  "nav.tax": "Taxes et e-facture",
  "nav.reconciliation": "Rapprochement",
  "nav.deductions": "Déductions",
  "nav.withholding": "Retenue à la source",
  "nav.cashflow": "Trésorerie",
  "nav.crm": "CRM",
  "nav.forecasts": "Prévisions",
  "nav.reminders": "Relances",
  "nav.dunning": "Recouvrement amiable",
  "nav.automation": "Automatisation",
  "nav.settings": "Paramètres",
  "nav.privacy": "Confidentialité",
  "group.receivables": "Créances",
  "group.planning": "Planification",
  "group.operations": "Opérations",
  "group.admin": "Administration",
  "app.tagline": "Revenue Operating System",
  "app.signOut": "Se déconnecter",
  "app.search": "Rechercher",
  "app.toggleTheme": "Changer de thème",
  "app.toggleNav": "Afficher la navigation",
  "app.language": "Langue",
  "app.useTenantDefault": "Utiliser la valeur par défaut",
  "state.loading": "Chargement…",
  "state.error": "Impossible de charger les données",
  "state.empty": "Rien pour le moment",
  "state.readOnly": "Lecture seule",
  "action.approve": "Approuver",
  "action.reject": "Rejeter",
  "action.save": "Enregistrer",
  "action.saving": "Enregistrement…",
  "action.saved": "Enregistré",
  "action.cancel": "Annuler",
  "action.export": "Exporter vers Excel",
};
export default fr;
